import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function SlidellProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Slidell"
      headingExtra="LA"
      introText="Slidell sits on the northeast shore of Lake Pontchartrain — New Orleans is only ~35 miles away across the Causeway, but that bridge has been shut down by hurricanes, fog, and accidents. Louisiana has a single passport agency in New Orleans serving 4.6M+ statewide residents. Here's how Northshore families compare their options, and why most choose a courier instead of betting on the Causeway."
      options={options}
      emergencyDescription="New Orleans ~35 mi via I-10/Causeway (45+ min in perfect conditions). Hurricane Katrina (2005) proved Slidell's vulnerability — the I-10 Twin Span Bridge collapsed and the Lake Pontchartrain Causeway was impassable for weeks. When the bridges are closed during severe weather or major accidents, New Orleans's single agency is unreachable. Louisiana's single passport agency serves 4.6M+ residents. Fog on the Causeway (Oct–Mar) routinely shuts down the bridge for hours with zero alternate route. Mardi Gras crowds (Feb–Mar) flood New Orleans and make getting an appointment impossible."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Nearest agency: New Orleans Passport Agency (~35 miles southwest, across Lake Pontchartrain)."
    />
  );
}